;(function ($) {
  "use strict"

  $(document).ready(function () {
    const isLarge = window.matchMedia("(min-width: 1000px)")

    $(".testimonial:nth-child(3), .testimonial:nth-child(6)")
      .find(".testimonial-content, figure > figcaption")
      .fadeToggle(function () {
        const isVisible = $(this).is(":visible")
        $(this).attr("aria-hidden", !isVisible)
      }) // Define the breakpoint in pixels

    function applyTestimonialLogic() {
      if (isLarge.matches) {
        // Large screen logic (row-based behavior)
        $(".testimonial-toggle")
          .off("click")
          .on("click", function () {
            const $this = $(this)
            const $testimonial = $this.closest(".testimonial")

            // Find the index of the clicked testimonial
            const index = $(".testimonial").index($testimonial)
            // Calculate the starting index of the row this testimonial belongs to
            const rowStartIndex = Math.floor(index / 4) * 4
            // Get all testimonials in the same row
            const $rowItems = $(".testimonial").slice(
              rowStartIndex,
              rowStartIndex + 4,
            )

            // Close all open testimonials in the same row first
            $rowItems
              .find(".testimonial-content")
              .not($testimonial.find(".testimonial-content"))
              .fadeOut()
            $rowItems
              .find("figure > figcaption")
              .not($testimonial.find("figure > figcaption"))
              .fadeIn()

            // Then toggle the clicked testimonial's content and figcaption
            $testimonial.find(".testimonial-content").fadeToggle(function () {
              const isVisible = $(this).is(":visible")
              $(this).attr("aria-hidden", !isVisible)
              $this.attr("aria-expanded", isVisible)
            })
            $testimonial.find("figure > figcaption").fadeToggle()
          })
      } else {
        // Small screen logic (single toggle behavior)
        $(".testimonial-toggle")
          .off("click")
          .on("click", function () {
            const $this = $(this)
            const $testimonial = $this.closest(".testimonial")

            // Close all open testimonials first
            $(".testimonial .testimonial-content")
              .not($testimonial.find(".testimonial-content"))
              .fadeOut()
            $(".testimonial figure > figcaption")
              .not($testimonial.find("figure > figcaption"))
              .fadeIn()

            // Then toggle the clicked testimonial's content and figcaption
            $testimonial.find(".testimonial-content").fadeToggle(function () {
              const isVisible = $(this).is(":visible")
              $(this).attr("aria-hidden", !isVisible)
              $this.attr("aria-expanded", isVisible)
            })
            $testimonial.find("figure > figcaption").fadeToggle()
          })
      }
    }

    // Initial call
    applyTestimonialLogic()

    // Re-apply logic on window resize
    $(window).on("resize", function () {
      applyTestimonialLogic()
    })
  })
})(jQuery)
